import React from "react";
import { useTranslation } from "react-i18next";
import LegalPageLayout, {
  LegalList,
  LegalSection,
  LegalText,
} from "./LegalPageLayout";

const Terms: React.FC = () => {
  const { t } = useTranslation();
  const section = (n: number) => `legal.terms.h${n}`;
  return (
    <LegalPageLayout title={t("legal.terms.title")} lastUpdated="2026-08-31">
      <p>{t("legal.terms.intro")}</p>

      <LegalSection heading={t(section(1))}>
        <p>{t("legal.terms.p1")}</p>
      </LegalSection>

      <LegalSection heading={t(section(2))}>
        <p>
          <LegalText k="legal.terms.p2" />
        </p>
      </LegalSection>

      <LegalSection heading={t(section(3))}>
        <LegalList
          items={["a", "b", "c", "d"].map((x) => t(`legal.terms.l3${x}`))}
        />
      </LegalSection>

      <LegalSection heading={t(section(4))}>
        <p>{t("legal.terms.p4")}</p>
      </LegalSection>

      <LegalSection heading={t(section(5))}>
        <p>{t("legal.terms.p5")}</p>
        <LegalList
          items={["a", "b", "c", "d"].map((x) => t(`legal.terms.l5${x}`))}
        />
      </LegalSection>

      <LegalSection heading={t(section(6))}>
        <p>{t("legal.terms.p6")}</p>
      </LegalSection>

      <LegalSection heading={t(section(7))}>
        <p>{t("legal.terms.p7")}</p>
      </LegalSection>

      <LegalSection heading={t(section(8))}>
        <p>{t("legal.terms.p8")}</p>
      </LegalSection>

      <LegalSection heading={t(section(9))}>
        <p>{t("legal.terms.p9")}</p>
      </LegalSection>

      <LegalSection heading={t(section(10))}>
        <p>{t("legal.terms.p10")}</p>
      </LegalSection>

      <LegalSection heading={t(section(11))}>
        <p>
          <LegalText k="legal.terms.p11" />
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default Terms;
